import type { FaireProductEntity } from "../../entity_types/product";

export const p_ya85a3q9cz: FaireProductEntity = {
  token: "p_ya85a3q9cz",
  type: "product",
  name: "Not Enough Sage For This Shit Tee",
  brandToken: "b_d849rxmheb",
  brandName: "Unknown Brand",
  imageUrl: "https://cdn.faire.com/fastly/53ad52594646fcee29f3340bf1d879ca69b437fae09c1acdb6cf66d053207405.jpeg",
  galleryImageUrls: [],
  priceDollars: 16.63,
  description: "For the days when your patience is on backorder and the vibes are anything but aligned—this tee gets it. Featuring a hand-drawn bundle of sage and vintage lettering, this design reads “Not Enough Sage in the World for This Sh*t,” and it's a whole mood. Perfect for boutique owners catering to boho babes, crystal collectors, and customers who live for honest humor with a spiritual twist. It's edgy, earthy, and guaranteed to spark some laughs (and maybe even sales).\nBella Heather Military Green\nThis updated essential unisex T shirt fits like a well-loved favorite, featuring a crew neck, short sleeves and designed with superior Airlume combed and ring-spun cotton.\n52% Airlume combed and ring-spun cotton, 48% poly\nPre-washed to minimize shrinkage\nTubular construction\nRibbed crew neck\nTaped neck and shoulders to provide durability\nDouble needle stitching on sleeves and bottom hem",
  tags: [],
  msrpDollars: 33.26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:47.115Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
